import { Controller } from "@hotwired/stimulus"

// Enables the wizard footer's Continue link the moment a legal acceptance
// streams in (TASK-101.2). The accepted state of the acceptance form carries
// data-legal-gate-target="accepted"; when Turbo swaps it into the frame this
// target connects and we lift the disabled affordance. The footer lives
// outside this controller's scope, hence the id lookup — and the server
// re-checks step order regardless, so this is presentation only.
export default class extends Controller {
  static targets = ["accepted"]

  acceptedTargetConnected() {
    const next = document.getElementById("wizard-next-action")
    if (!next) return

    next.classList.remove("pointer-events-none", "opacity-50")
    next.removeAttribute("aria-disabled")
    next.removeAttribute("tabindex")
  }
}
